'use client'

import { useRouter } from 'next/navigation'
import { ReactNode } from 'react'
import { atom, useRecoilState } from 'recoil'

import Button from '@/components/Button'
import Dialog from '@/components/Context/DialogProvider/Dialog'
import { addBrowsingParameter } from '@/utils/urlUtils'

export const dialogState = atom<Props | null>({
  key: 'dialog',
  default: null,
})
export type Props = {
  message: string
  title?: string
  href?: string
  buttonText?: string
  closeButtonAction?: () => void
}

export default function DialogProvider({ children }: { children: ReactNode }) {
  return (
    <>
      <Alert />
      {children}
    </>
  )
}

function Alert() {
  const [dialog, setDialog] = useRecoilState(dialogState)
  const router = useRouter()

  return (
    <>
      {dialog != null && (
        <Dialog
          show={dialog != null}
          closeButtonAction={dialog.closeButtonAction == undefined ? null : dialog.closeButtonAction}
          afterSubmit={() => setDialog(null)}
        >
          <>
            {dialog.title ? <h2 className={'c-dialog__content-title'}>{dialog.title}</h2> : <></>}
            <div className={'c-dialog__content-message'}>{dialog.message}</div>
            {dialog.href && dialog.buttonText ? (
              <Button
                onClick={() => {
                  router.push(addBrowsingParameter(dialog.href!))
                  setDialog(null)
                }}
                fontSize={'1.5rem'}
                maxHeight={'4rem'}
                width={'100%'}
              >
                {dialog.buttonText}
              </Button>
            ) : (
              <div
                className={'c-dialog__content-button'}
                style={{
                  display: 'flex',
                  justifyContent: 'end',
                }}
              >
                <Button
                  onClick={() => {
                    if (dialog.closeButtonAction != null) {
                      dialog.closeButtonAction()
                    }

                    setDialog(null)
                  }}
                  fontSize={'1rem'}
                  maxHeight={'3rem'}
                >
                  閉じる
                </Button>
              </div>
            )}
          </>
        </Dialog>
      )}
    </>
  )
}
